<template>
  <div class="room-voice-request-component" :class="{ requested: isRequestSpeak || hasRequestSpeak }">
    <div class="room-voice-request">
      <div class="room-voice-request-button-container" v-if="hasEmceeRole()">
        <span v-if="!isMobile" class="room-voice-request-button-text">{{ $t("voice.title") }}</span>
        <button class="room-voice-request-button" @click="onToggleVoiceRequestList" />
      </div>
      <div class="room-voice-request-button-container" v-else>
        <span v-if="!isMobile" class="room-voice-request-button-text">{{ !isRequestSpeak ? $t('voice.title') : $t('voice.cancel') }}</span>
        <button class="room-voice-request-button" @click="toggleRequestSpeak" />
      </div>
    </div>
  </div>
</template>

<script>
import VoiceRequestList from '@/components/Room/Voice/List'

import {mapActions, mapGetters, mapMutations} from "vuex";
import {Device} from "@/utils";

export default {
  name: "VoiceRequest",
  data() {
    return {
      isRequestSpeak: false,
      reqSpeakId: '',
      hasRequestSpeak: false
    }
  },
  created() {
    this.$roomApi.addEventListeners((this._Events = _Events()), this)
    this.$modal(VoiceRequestList, {
      exist: true
    })
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
  },
  computed: {
    ...mapGetters('user', [
        'hasEmceeRole',
        'isMe',
        'getUsername',
        'hasRoleFunction'
    ]),
    isMobile() {
      return Device.isMobile();
    }
  },
  methods: {
    ...mapActions('user', [
       'requestSpeak',
       'cancelRequestSpeak',
       'confirmRequestSpeak',
    ]),
    ...mapMutations('common', [
       'SET_OPEN_VOICEREQUEST'
    ]),
    onToggleVoiceRequestList() {
      this.hasRequestSpeak = false
      this.$modal(VoiceRequestList)
    },
    toggleRequestSpeak() {
      if(this.hasRoleFunction('mic')) {
        this.$alert(this.$t('voice.hasVoice'))
        return;
      }
      if(!this.isRequestSpeak) {
        this.requestSpeak()
      } else {
        this.cancelRequestSpeak(this.reqSpeakId)
      }
    },
  }
}
function _Events(){
  return {
    room_user_requestSpeak: function(e) {
      const userId = e.userId,
          reqSpeakId = e.data.reqSpeakId;

      if(this.isMe(userId)) {
        this.reqSpeakId = reqSpeakId
        this.isRequestSpeak = true
      }
      if(this.hasEmceeRole()) {
        this.hasRequestSpeak = true
      }
    },
    room_user_cancelRequestSpeak: function(e) {
      const userId = e.userId;

      if(this.isMe(userId)) {
        this.reqSpeakId = ''
        this.isRequestSpeak = false
      }
    },
    room_user_confirmRequestSpeak: function(e) {
      const {reqUserId} = e.data;
      if(this.isMe(reqUserId)) {
        this.reqSpeakid = ''
        this.isRequestSpeak = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.room-voice-request-component {
  &.requested {
    &::before {
      content: '';
      background-color: #59f;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      opacity: 0.9;
      transition: 0.1s ease-out;
    }
    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }
}
.room-voice-request {
  margin-left: 4px;
}
.room-voice-request-button-container {}
.room-voice-request-button-text {
  font-size: 13px;
  color: #fff;
  position: relative;
}
.room-voice-request-button {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>